import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DashboardView from "ToddleAnalytics/routes/Dashboards/routes/DashboardView";

export default store => {
  return {
    path: "pinned-dashboards",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import(/* webpackChunkName: "ai" */ "./components")]).then(
          ([importedModule0]) => {
            const component = importedModule0.default;
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [DashboardView(store)],
  };
};
